import { Component, ContentChildren, Input, QueryList } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FaqQuestionComponent } from '../faq-question/faq-question.component';

@Component({
    selector: 'app-faq-section',
    templateUrl: './faq-section.component.html',
    styleUrl: './faq-section.component.scss',
    standalone: false
})
export class FaqSectionComponent {
  @Input() sectionTitle: string;
  @Input() showExpand: boolean= true;
  @ContentChildren(FaqQuestionComponent) questions: QueryList<FaqQuestionComponent>;
  expandAll: boolean = false;
  expanded: number = 0;

  currentLang: string;
  constructor(public translateService: TranslateService) {
    this.currentLang = translateService.currentLang;
    translateService.onLangChange.subscribe(lang => this.currentLang = lang.lang);
  }

  ngAfterViewInit(): void {
    for (let q of this.questions)
      q.expandQuestion.subscribe((x: boolean) => {
        if (x) this.expanded++; else this.expanded--;
        if (this.expanded == 0) this.expandAll = false;
        else if (this.expanded == this.questions.length) this.expandAll = true;
      });
  }

  expand() {
    this.expandAll = !this.expandAll;
    for (let q of this.questions) q.expand = this.expandAll;
    this.expanded = this.expandAll ? this.questions.length : 0;
  }
}
